// extracted by mini-css-extract-plugin
export var thumbnail = "Sensei-module--thumbnail--d64c5";
export var wrapper = "Sensei-module--wrapper--c5c3d";